import api from "../utils/axios/axiosConfig";

const clientsService = {
  create: (data) => api.post("/clients/create", data),

  update: (id, data) => api.put(`/clients/update/${id}`, data),

  delete: (id) => api.delete(`/clients/delete/${id}`),

  get: (id) => api.get(`/clients/get/${id}`),

  search: (params) => api.post("/clients/search", params),

  searchClients: () => api.get("/clients/search-clients"),
};

export default clientsService;
